import { Component, ElementRef, OnInit } from '@angular/core';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import * as moment from 'moment';
import { FindBookingDialog, RentalDialog } from '../../../../t4common';
import { PageBase, RentalInfo, RentalObjectInfo } from 't4core';


export const MY_FORMATS = {
    parse: {
        dateInput: 'MM/YYYY',
    },
    display: {
        dateInput: 'MMMM YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY',
    },
};

@Component({
    styleUrls: ['./ClerkDashboard.css'],
    selector: 'ClerkDashboard',
    templateUrl: './ClerkDashboard.html',
    providers: [
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    ],
})
export class ClerkDashboardComponent extends PageBase implements OnInit {
    public activeBookings: RentalInfo[];
  public upcomingBookings: RentalInfo[];
  private objects: RentalObjectInfo[] = [];

    constructor(el: ElementRef) {
        super(el, "Bookings");
    }

    public async ngOnInit() {
        this.loadData();
    }

    public loading = {
        active: false,
        upcoming: false
    }

    public findBooking() {
        var dlg = this.Dialog.open(FindBookingDialog, {});
    }

    public async loadData() {

        // Active bookings
        this.loading.active = true;
        this.Api.get<RentalInfo[]>("Rental/GetActiveRentals").then(x => {
            this.activeBookings = x;

            this.loading.active = false;
        });

        // Upcoming bookings
        this.loading.upcoming = true;
        await this.Api.get<RentalInfo[]>("Rental/GetUpcomingRentals").then(x => {
            this.upcomingBookings = x;
          this.loading.upcoming = false;
            
        });

      this.objects = await this.Api.get<RentalObjectInfo[]>("RentalObject/GetMyObjects");
    }

  public async addBooking() {
    if (!this.objects) return;

        var start = moment();
        var end = moment();
        var obj: number = 0;

        let i = await RentalDialog.newBooking(this.Dialog, {
            pickupTime: start,
            returnTime: end,
            pickupLocationId: this.Settings.clientSettings.RentalLocationId,
            returnLocationId: this.Settings.clientSettings.RentalLocationId,
            objectId: this.objects[0].Id,
            typeId: this.objects[0].Type.Id
        }, this.Settings);

            if (i) {
                this.loadData();
            }
    }
}
